import { isAxiosError } from "axios";

// Extrai uma mensagem de erro amigável de um erro vindo do axios.
// Tenta os campos error_description (padrão OAuth/Authlib do backoffice),
// message e detail (formato {type, title, status, detail} do accounts); cai
// num fallback se o servidor não retornou texto utilizável.
export function getApiErrorMessage(
  error: unknown,
  fallback = "Ocorreu um erro inesperado.",
): string {
  if (isAxiosError(error)) {
    const data = error.response?.data;
    if (data && typeof data === "object") {
      const desc = (data as { error_description?: unknown }).error_description;
      if (typeof desc === "string" && desc.trim()) return desc;
      const msg = (data as { message?: unknown }).message;
      if (typeof msg === "string" && msg.trim()) return msg;
      const detail = (data as { detail?: unknown }).detail;
      if (typeof detail === "string" && detail.trim()) return detail;
    }
    if (!error.response) {
      return "Falha de conexão. Tente novamente.";
    }
    return `${fallback} (HTTP ${error.response.status})`;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
